import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import getQuizData from '../lib/getQuizData';
import { normaliseKey } from '../lib/string';
import Svg from './Svg';
import haircareSteps from '../lib/haircareQuiz';
import supplementSteps from '../lib/supplementQuiz';
import submitQuiz from '../lib/api';

const QuizHistory = ({onClose}) => {
    const quizType = localStorage.getItem('quiz-type');
    let quizHistory = JSON.parse(localStorage.getItem('quiz-history-' + quizType));
    const displayLimit = 3;
    const [isLoading, setIsLoading] = useState(false);

    // sort quizes by most recent first and limit to 3 latest
    quizHistory.sort(function(a,b){
        return new Date(b.created) - new Date(a.created);
    });
    quizHistory = quizHistory.slice(0, displayLimit);

    function prettyDate(timestamp){
        var a = new Date(timestamp * 1000);
        var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        var time = `${month} ${date}, ${year}`;
        return time;
    }

    const applyPrevQuizData = async (hash) => {
        setIsLoading(true);
        setTimeout(async () => {
            const data = await getQuizData(hash);
            if (data.quizData) {
                let currentQuizSteps = quizType === 'haircare' ? haircareSteps : supplementSteps;
                let activeStep = currentQuizSteps.length - 1;
                let activeSubStep = currentQuizSteps[activeStep].steps.length - 1;

                // set default state options
                let newQuizState = {
                    activeStep: activeStep,
                    activeSubStep: activeSubStep,
                    highestStep: 5, // this allows the user to immediately navigate between all steps up to 5
                    submitting: false,
                    hideScreen: false,
                    persistedQuery: null,
                };

                // update Quiz data to match the expected format
                const hashData = data.quizData;
                Object.keys(hashData).forEach((key) => {
                    newQuizState[normaliseKey(key)] = hashData[key];
                });

                // set state and reload page
                localStorage.setItem('order-form-state-' + quizType, JSON.stringify(newQuizState));
                submitQuiz(newQuizState);
            } else {
                setIsLoading(false);
                alert('Sorry, we couldn\'t restore the selected quiz data. Please try another or start over.');
            }
        }, 500);
    }

    return (
    <div className="quiz-history-modal">
        <div className="quiz-modal-bg"></div>
        <div className={`quiz-modal-content bg-light ${isLoading ? 'is-loading' : ''} `}>
            <button type="button" className="btn quiz-modal-close" onClick={onClose}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.10561 0.0115749L6.24219 4.14815L10.3788 0.0115735L11.8637 1.4965L7.72711 5.63307L11.8637 9.76965L10.3788 11.2546L6.24218 7.118L2.10561 11.2546L0.620687 9.76965L4.75726 5.63307L0.620688 1.4965L2.10561 0.0115749Z" fill="#212322"/>
                </svg>
            </button>
            <h3>Welcome back!</h3>
            <p>We've found some previous quiz submissions. Select one from the list below to prefill your answers, or start over.</p>
            <table className="quiz-history-list">
                <tbody>
                {quizHistory.map((quiz, i) => (
                    <tr className="quiz-history-item" key={i}>
                        <td>
                            <a onClick={() => applyPrevQuizData(quiz.hash)} className="quiz-name quiz-name-full">{quiz.name}</a>
                            <a onClick={() => applyPrevQuizData(quiz.hash)} className="quiz-name quiz-name-trunc">{quiz.name.length > 9 ? `${quiz.name.substring(0, 9)}...` : quiz.name}</a>
                        </td>
                        <td><span className="quiz-date">{prettyDate(quiz.created)}</span></td>
                        <td><a onClick={() => applyPrevQuizData(quiz.hash)} className="use-button btn btn-primary">Use</a></td>
                    </tr>
                ))}
                </tbody>
            </table>
            <button type="button" className="btn btn-outline-primary start-over-button" onClick={onClose}>
                Start over {isLoading && (<Svg name={'spinner'} spin={true} />)}
            </button>
        </div>
    </div>
    );
};

QuizHistory.propTypes = {
    onClose: PropTypes.func,
};

QuizHistory.defaultProps = {
    onClose: () => {},
};

export default memo(QuizHistory);
